var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCidImage = function SvgCidImage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 281,
    height: 236,
    viewBox: "0 0 281 236",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .a{fill:none;}.b{fill:#fff;}.c,.d{fill:#4b4b4b;}.c{font-size:15px;font-family:Ubuntu-Bold, Ubuntu;font-weight:700;}.d{font-size:12px;font-family:Ubuntu;letter-spacing:0.09em;}.e{fill:#e2e2e2;}.f{fill:#fd0d1b;}.g{fill:red;fill-rule:evenodd;}.h{filter:url(#a);}\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 281,
    height: 236,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-543 -119)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 15.7,
    height: 176,
    transform: "translate(557.3 149)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "matrix(1, 0, 0, 1, 543, 109)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 221,
    height: 176,
    transform: "translate(30 30)"
  })), /*#__PURE__*/React.createElement("text", {
    className: "c",
    transform: "translate(598 177)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Pedido m\xE9dico")), /*#__PURE__*/React.createElement("text", {
    className: "d",
    transform: "translate(666 235)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CID10-F41")), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 173,
    height: 6,
    rx: 3,
    transform: "translate(598 197)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 173,
    height: 6,
    rx: 3,
    transform: "translate(598 213)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 173,
    height: 6,
    rx: 3,
    transform: "translate(598 245)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 63,
    height: 6,
    rx: 3,
    transform: "translate(598 229)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 85,
    height: 6,
    rx: 3,
    transform: "translate(598 261)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 39,
    height: 6,
    rx: 3,
    transform: "translate(732 229)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(704 237.285)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.037 30.2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.082 0.822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.957,58.089c-6.053,0-11.006-1.582-13.139-4.2a10.313,10.313,0,0,1-4.953,2.2,3.7,3.7,0,0,1-3.508-2.064c-1.445-2.683-1.032-7.911,3.1-13.62.688-.894,6.535-8.667,10.043-7.5,1.445.482,2.2,2.27,2.2,5.71h-.688c0-2.752-.619-4.746-1.72-5.09-2.132-.688-6.329,3.3-9.287,7.292-3.99,5.434-4.4,10.318-3.027,12.864a2.987,2.987,0,0,0,2.889,1.72,9.6,9.6,0,0,0,4.54-2.132,4.012,4.012,0,0,1-.55-1.238c-.825-2.752,1.169-5.778,5.572-8.186,5.022-2.752,10.25-4.4,14.1-4.609.344-.55.619-1.032.963-1.513,3.921-6.329,4.127-6.535,4.54-6.26.413.206.55.275-2.27,6.673-.206.413-.344.825-.55,1.238A4.422,4.422,0,0,1,56.1,40.754c.963,1.169,1.376,3.508-2.408,8.186-4.4,5.434-5.5,6.191-6.191,5.778S46.607,52.792,52.248,40H50.941c-6.26,10.043-9.768,15-11.35,14.377A2.638,2.638,0,0,1,37.94,53a3.153,3.153,0,0,1,.482-2.408,4.074,4.074,0,0,0,.55-1.857v-.069h0c-.413,0-2.064,1.376-3.439,2.408-.963.757-1.995,1.651-3.1,2.408,2.2,2.614,7.911,4.54,16.166,3.715,15.34-1.513,23.113-15.2,23.182-15.34l.619.344c-.069.138-8.048,14.171-23.732,15.684A35.556,35.556,0,0,1,44.957,58.089Zm7.98-18.229c-5.022,11.35-5.366,13.964-5.09,13.964h0c.344,0,1.513-.825,5.3-5.5,2.752-3.371,3.508-5.916,2.408-7.292A4.223,4.223,0,0,0,52.936,39.86ZM38.972,47.977a.414.414,0,0,1,.275.069.75.75,0,0,1,.413.619,4.267,4.267,0,0,1-.619,2.2,2.451,2.451,0,0,0-.413,1.857,2.072,2.072,0,0,0,1.307.963c1.307.482,6.741-7.98,10.25-13.689a36.5,36.5,0,0,0-13.345,4.54c-4.127,2.27-6.053,4.953-5.3,7.36a6.943,6.943,0,0,0,.482,1.032c1.1-.757,2.132-1.651,3.1-2.408C37.115,48.871,38.215,47.977,38.972,47.977ZM51.56,39.309a4.23,4.23,0,0,1,.963.069c.206-.482.413-.894.619-1.376.963-2.2,1.582-3.646,1.995-4.54-.757,1.169-1.926,3.027-3.027,4.815-.206.413-.482.757-.688,1.1C51.423,39.309,51.492,39.309,51.56,39.309Z",
    transform: "translate(-22.6 -31.395)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.62,57.165A5.266,5.266,0,0,1,5.7,55.239a2.435,2.435,0,0,1-.482-2.614C6.112,50.011,11,46.847,17.6,44.1c1.032-4.334,1.238-7.636.206-13.758l.688-.138c1.032,6.053.825,9.424-.069,13.552a91.458,91.458,0,0,1,19.192-5.434l.138.688a90.574,90.574,0,0,0-19.467,5.5c-.344,1.445-.825,3.027-1.307,4.884-1.169,4.265-3.439,7.017-6.122,7.636A4.244,4.244,0,0,1,9.62,57.165Zm7.7-12.313c-6.191,2.614-10.662,5.572-11.488,7.98a1.779,1.779,0,0,0,.344,1.926,4.411,4.411,0,0,0,4.334,1.582c2.408-.55,4.54-3.233,5.572-7.085A33.329,33.329,0,0,0,17.325,44.852Z",
    transform: "translate(-5.037 -30.2)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(540.964 1190.846) rotate(-164)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M45.261,958.362a2.65,2.65,0,0,0-1.159,5.009l10.974,5.671A53.125,53.125,0,0,0,11.1,1009.485a2.65,2.65,0,1,0,5.135,1.2,47.758,47.758,0,0,1,41.2-36.593L47.373,984.151a2.65,2.65,0,1,0,3.727,3.767l15.2-15.192a2.649,2.649,0,0,0-.663-4.222l-19.09-9.811A2.653,2.653,0,0,0,45.261,958.362Z",
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1501.581 461.727)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M31.507,30.209a11.078,11.078,0,0,1,5.067,5.245c.5,1.064,1.241-.642.729-2.288a4.542,4.542,0,0,0-1.073-1.74,20.564,20.564,0,0,1,1.881,1.259c2.878,2.187,4.848,5.257,4.8,8.082-.152,8.655-10.41,11.916-14.82,12.175a19.625,19.625,0,0,1-11.711-3.12A11.608,11.608,0,0,1,11,42.017a8.31,8.31,0,0,1,.512-4.127,11.489,11.489,0,0,1,2.65-3.97,17.715,17.715,0,0,1,9.614-4.7A13.289,13.289,0,0,1,31.507,30.209Zm-4.661-3.935a.955.955,0,0,0-.856.728,14.988,14.988,0,0,0-3.94.391,17.765,17.765,0,0,0-8.777,4.474,13.307,13.307,0,0,0-3.1,4.713,12.442,12.442,0,0,0-.706,5.957,13.46,13.46,0,0,0,6.21,9.567,20.7,20.7,0,0,0,12.3,3.125,20.582,20.582,0,0,0,12.06-4.506,13.306,13.306,0,0,0,4.676-10.279,12.952,12.952,0,0,0-5.446-9.922A21.771,21.771,0,0,0,26.847,26.274Z",
    transform: "translate(-810 -262.194)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCidImage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cid-image.ae8dd077.svg";
export { ForwardRef as ReactComponent };